// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-682a9056] {\n  box-sizing: border-box;\n}\ndiv[data-v-682a9056] {\n  padding: 0;\n}\n.div-top[data-v-682a9056],\n.div-search[data-v-682a9056] {\n  line-height: 30px;\n}\n.div-search[data-v-682a9056] {\n  margin-top: 10px;\n}\n.div-center[data-v-682a9056] {\n  margin-top: 10px;\n  height: calc(100% - 40px);\n}\n.title[data-v-682a9056] {\n  font-size: 20px;\n  font-weight: bold;\n  line-height: 40px;\n}", ""]);
// Exports
module.exports = exports;
